import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

import { ApprovalRequest } from '../components/proposal-details/models/approval-request.model';
import { ProposalService } from '../services/sections/job/proposal.service';

@Injectable({
	providedIn: 'root'
})
export class CustomerProposalResolver implements Resolve<Observable<ApprovalRequest>> {

	constructor(
		private router: Router,
		private proposalService: ProposalService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.proposalService
			.getCustomerProposal(activatedRouteSnapshot.paramMap.get('token'), Number(activatedRouteSnapshot.paramMap.get('proposalId')))
			.pipe(
				catchError((e) => {
					this.router.navigate(['/404']);
					// GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
